<template>
  <div>
    <div
      v-if="loadingRemotions"
      class="d-flex justify-content-center align-items-center"
      style="height: 300px"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header">
          <div class="title bold">Remoções</div>
        </div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-4">
              <label>Destino</label>
              <v-select
                :options="destinos"
                :reduce="(destino) => destino.destino_id"
                :label="'destino_nome'"
                v-model="filters.destination_hospital"
                class="vselect"
                @input="onDestinationChange"
              />
            </div>
            <div class="col-md-2">
              <label>Número da Ficha</label>
              <input
                type="text"
                class="form-control"
                v-model="filters.card_number"
                v-on:input="debounceCard()"
              />
            </div>
            <div class="col-md-2">
              <label>Início da Remoção</label>
              <input
                type="date"
                class="form-control"
                v-model="filters.start_date"
                v-on:input="getEntity()"
              />
            </div>
            <div class="col-md-2">
              <label>Fim da Remoção</label>
              <input
                type="date"
                class="form-control"
                v-model="filters.end_date"
                v-on:input="getEntity()"
              />
            </div>

            <div class="col-md-2">
              <label>Status</label>
              <v-select
                :options="statuses"
                :reduce="(s) => s.id"
                :label="'name'"
                v-model="filters.status"
                @input="getEntity"
                class="vselect"
              />
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <div class="w-100 d-flex" style="gap: 8px">
                <button
                  class="btn btn-primary"
                  @click="exportExcel"
                  :disabled="isLoading"
                >
                  {{ isLoading ? "Exportando..." : "Exportar Excel" }}
                </button>

                <button
                  class="btn btn-secondary flex-grow-1"
                  @click="clearFilters"
                >
                  Limpar filtros
                </button>

                <button
                  class="btn btn-success"
                  v-if="!auto_refresh"
                  @click="autoRefreshing"
                >
                  Atualizar Automaticamente <i class="fas fa-sync"></i>
                </button>
                <button class="btn btn-danger" v-else @click="autoRefreshing">
                  Parar <i class="fas fa-sync"></i>
                </button>
              </div>
            </div>
          </div>

          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Número Ficha</th>
                <th scope="col">Destino</th>
                <th scope="col">Usuário</th>
                <th scope="col">Veículo</th>
                <th scope="col">Início da Remoção</th>
                <th scope="col">Fim da Remoção</th>
                <th scope="col">Status</th>
                <th scope="col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="removals.length === 0">
                <td colspan="9" class="text-center text-muted py-4">
                  Nenhuma remoção encontrada
                </td>
              </tr>
              <tr v-for="removal in removals" :key="removal.id">
                <th scope="row">{{ removal.id }}</th>
                <td>{{ removal.card_number }}</td>
                <td>{{ removal.destination_hospital }}</td>
                <td>
                  {{
                    removal.user && removal.user.name ? removal.user.name : "-"
                  }}
                </td>
                <td>
                  {{
                    removal.vehicle && removal.vehicle.name
                      ? removal.vehicle.name
                      : "-"
                  }}
                </td>
                <td>{{ removal.start_date_f || removal.start_date || "-" }}</td>
                <td>{{ removal.end_date_f || removal.end_date || "-" }}</td>
                <td>
                  <span
                    :class="
                      removal.status === 1
                        ? 'badge badge-success'
                        : 'badge badge-warning'
                    "
                    >{{
                      removal.status === 1 ? "Finalizado" : "Iniciado"
                    }}</span
                  >
                </td>
                <td>
                  <button class="btn btn-add" @click="getPositions(removal)">
                    <i class="fas fa-map-marker-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Paginação -->
          <div class="row mt-3" v-if="pagination.total > 0">
            <div class="col-12">
              <div class="d-flex flex-column align-items-center">
                <nav aria-label="Navegação de página">
                  <ul class="pagination mb-2">
                    <li
                      class="page-item"
                      :class="{ disabled: pagination.current_page === 1 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPage(pagination.current_page - 1)"
                      >
                        Anterior
                      </a>
                    </li>

                    <li
                      v-for="page in visiblePages"
                      :key="page"
                      class="page-item"
                      :class="{ active: page === pagination.current_page }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPage(page)"
                      >
                        {{ page }}
                      </a>
                    </li>

                    <li
                      class="page-item"
                      :class="{
                        disabled:
                          pagination.current_page === pagination.last_page,
                      }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPage(pagination.current_page + 1)"
                      >
                        Próximo
                      </a>
                    </li>
                  </ul>
                </nav>
                <p class="text-muted mb-0 small">
                  Mostrando {{ pagination.from }} a {{ pagination.to }} de
                  {{ pagination.total }} registros
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Mapa -->
    <div
      class="modal fade"
      id="modalMap"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalMapTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Informações do dispositivo
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div ref="mapContainer" class="map-wrapper">
                  <GmapMap
                    ref="mapRef"
                    :zoom="19"
                    :center="currentLocation"
                    style="width: 100%; height: 900px"
                  >
                    <!-- Marcadores (início / intermediários / fim) -->
                    <GmapMarker
                      v-for="(position, idx) in filteredPositions"
                      :key="position.id || idx"
                      :icon="markerIcon(idx, filteredPositions.length)"
                      :position="position"
                      @click="openPositionInfo(position, idx)"
                    />

                    <!-- InfoWindow exibindo lat/lng e horário ao clicar no marker -->
                    <GmapInfoWindow
                      v-if="infoWindowPosition"
                      :position="{
                        lat: infoWindowPosition.lat,
                        lng: infoWindowPosition.lng,
                      }"
                      :opened="infoWindowOpened"
                      @closeclick="closePositionInfo"
                    >
                      <div style="min-width: 160px">
                        <div>
                          <strong>Ponto:</strong>
                          {{ infoWindowContent.indexLabel }}
                        </div>
                        <div>
                          <strong>Latitude:</strong> {{ infoWindowContent.lat }}
                        </div>
                        <div>
                          <strong>Longitude:</strong>
                          {{ infoWindowContent.lng }}
                        </div>
                        <div>
                          <strong>Horário:</strong>
                          {{ infoWindowContent.time || "-" }}
                        </div>
                      </div>
                    </GmapInfoWindow>

                    <!-- Segmentos de rota: dados GPS reais (azul) -->
                    <GmapPolyline
                      v-for="(segment, index) in routeSegments"
                      :key="'segment-' + index"
                      :path="segment.path"
                      :options="{
                        strokeColor: segment.isGap ? '#FF6B35' : '#4169e1',
                        strokeOpacity: segment.isGap ? 0.7 : 0.9,
                        strokeWeight: segment.isGap ? 3 : 4,
                        geodesic: true,
                      }"
                    />
                  </GmapMap>

                  <!-- Overlay transparente para capturar o mapa -->
                  <div class="map-overlay"></div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <span class="bold"> Legenda: </span>Ícone de Posição Inicial:
                <img
                  src="@/assets/images/logo/icons8-mapa-start-24.svg"
                  width="20"
                  alt="Início"
                />
                Ícone de Posição Final:
                <img
                  src="@/assets/images/logo/icons8-mapa-end-24.svg"
                  width="20"
                  alt="Fim"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 bold">Histórico de Posições</div>

              <div class="col-md-12">
                <button
                  class="btn btn-secondary mt-2"
                  @click="exportPDF()"
                  :disabled="isLoading"
                >
                  {{ isLoading ? "Exportando..." : "Exportar PDF" }}
                </button>

                <a
                  v-if="filteredPositions && filteredPositions.length > 0"
                  :href="generateGoogleMapsUrl()"
                  target="_blank"
                  class="btn btn-primary mt-2 ml-2"
                  style="text-decoration: none"
                >
                  <i class="fa fa-map-marker"></i> Ver no Google Maps
                </a>
              </div>

              <!-- Legenda de rotas -->
              <div class="col-md-12 mt-2">
                <small class="text-muted">
                  <span style="color: #4169e1; font-weight: bold">━━━</span>
                  Dados GPS reais &nbsp;&nbsp;
                  <span style="color: #ff6b35; font-weight: bold">━━━</span>
                  Rota estimada (sem sinal GPS)
                </small>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-12">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Latitude</th>
                      <th scope="col">Longitude</th>
                      <th scope="col">Data/Hora</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pos in positions" :key="pos.id">
                      <th scope="row">{{ pos.id }}</th>
                      <td>{{ pos.lat }}</td>
                      <td>{{ pos.lng }}</td>
                      <td>{{ pos.created_at_f || "-" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Mapa -->
    <div
      class="modal fade"
      id="modalRemovals"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalRemovalsTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Remoções</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Número Ficha</th>
                  <th scope="col">Destino</th>
                  <th scope="col">Usuário</th>
                  <th scope="col">Veículo</th>
                  <th scope="col">Início da Remoção</th>
                  <th scope="col">Fim da Remoção</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="removal in data_modal_removal" :key="removal.id">
                  <th scope="row">{{ removal.id }}</th>
                  <td>{{ removal.card_number }}</td>
                  <td>{{ removal.destination_hospital }}</td>
                  <td>{{ removal.user.name }}</td>
                  <td>{{ removal.vehicle.name }}</td>
                  <td>{{ removal.start_date_f || "-" }}</td>
                  <td>{{ removal.end_date_f || "-" }}</td>
                  <td>
                    <span
                      :class="
                        removal.status === 1
                          ? 'badge badge-success'
                          : 'badge badge-warning'
                      "
                      >{{
                        removal.status === 1 ? "Finalizado" : "Iniciado"
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      timeLeft: 20,
      auto_refresh: false,
      intervalId: null,
      center_id: null,
      unit_id: null,
      filterStatus: null,
      filterStatus_: null,
      intervalIdChronometer: null,
      activities: [],
      centers: [],
      destinos: [],
      removals: [],
      positions: [],
      units: [],
      data_modal_removal: [],
      vehicleslist: [],
      data_modal: {},
      dashboard: {},
      selectedVehicle: {},
      currentLocation: { lat: 0, lng: 0 },
      filters: {
        destination_hospital: null,
        start_date: "",
        end_date: "",
        card_number: "",
        status: "",
      },
      statuses: [
        { id: "", name: "Todos" },
        { id: 1, name: "Finalizado" },
        { id: 0, name: "Iniciado" },
      ],
      selectedRemoval: null,
      isLoading: false,
      routeSegments: [],
      directionsRenderers: [],
      currentRemovalId: null,
      cachedEstimatedRoutes: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0,
        from: 0,
        to: 0,
      },
      loadingRemotions: false,
      infoWindowPosition: null,
      infoWindowOpened: false,
      infoWindowContent: {},
    };
  },
  components: {},
  computed: {
    visiblePages() {
      const pages = [];
      const current = this.pagination.current_page;
      const last = this.pagination.last_page;

      if (last <= 5) {
        for (let idx = 1; idx <= last; idx++) {
          pages.push(idx);
        }
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, 5);
        } else if (current >= last - 2) {
          pages.push(last - 4, last - 3, last - 2, last - 1, last);
        } else {
          pages.push(
            current - 2,
            current - 1,
            current,
            current + 1,
            current + 2,
          );
        }
      }
      return pages;
    },
    filteredPositions() {
      if (this.positions.length < 2) return this.positions;

      const filtered = [this.positions[0]];

      for (let idx = 1; idx < this.positions.length; idx++) {
        const prev = this.positions[idx - 1];
        const current = this.positions[idx];

        const distance = this.calculateDistance(
          prev.lat,
          prev.lng,
          current.lat,
          current.lng,
        );

        let timeDiffSeconds = 10;

        if (prev.created_at_f && current.created_at_f) {
          try {
            const prevTime = new Date(prev.created_at_f).getTime() / 1000;
            const currTime = new Date(current.created_at_f).getTime() / 1000;
            timeDiffSeconds = Math.abs(currTime - prevTime);
          } catch (e) {
            console.warn("Erro ao calcular diferença de tempo:", e);
          }
        }

        const speedKmh =
          timeDiffSeconds > 0 ? (distance / timeDiffSeconds) * 3.6 : 0;

        if (timeDiffSeconds > 20) {
          filtered.push(current);
        } else if (speedKmh > 200) {
          console.warn(
            `Ponto ${idx} removido: velocidade de ${Math.round(
              speedKmh,
            )} km/h (${Math.round(distance)}m em ${timeDiffSeconds}s)`,
          );
        } else {
          filtered.push(current);
        }
      }

      return filtered;
    },
  },
  methods: {
    autoRefreshing() {
      const self = this;
      self.startCountdown();

      if (!self.auto_refresh) {
        self.intervalId = setInterval(() => {
          self.getEntity();
          self.startCountdown();
        }, 20000);
      } else {
        if (self.intervalId) clearInterval(self.intervalId);
      }

      self.auto_refresh = !self.auto_refresh;
    },

    startCountdown() {
      if (this.intervalIdChronometer) clearInterval(this.intervalIdChronometer);
      this.timeLeft = 20;

      this.intervalIdChronometer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft < 0) this.timeLeft = 20;
      }, 1000);
    },
    onDestinationChange() {
      this.getEntity();
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      const earthRadius = 6371e3;
      const lat1Rad = (lat1 * Math.PI) / 180;
      const lat2Rad = (lat2 * Math.PI) / 180;
      const deltaLat = ((lat2 - lat1) * Math.PI) / 180;
      const deltaLon = ((lon2 - lon1) * Math.PI) / 180;

      const haversineA =
        Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(lat1Rad) *
          Math.cos(lat2Rad) *
          Math.sin(deltaLon / 2) *
          Math.sin(deltaLon / 2);
      const centralAngle =
        2 * Math.atan2(Math.sqrt(haversineA), Math.sqrt(1 - haversineA));

      return earthRadius * centralAngle;
    },

    processRouteSegments() {
      const self = this;
      const GAP_THRESHOLD = 5 * 60;

      self.directionsRenderers.forEach((renderer) => {
        renderer.setMap(null);
      });
      self.directionsRenderers = [];
      self.routeSegments = [];

      if (self.filteredPositions.length < 2) {
        self.routeSegments = [{ path: self.filteredPositions, isGap: false }];
        return;
      }

      let currentSegment = [self.filteredPositions[0]];

      for (let idx = 1; idx < self.filteredPositions.length; idx++) {
        const prev = self.filteredPositions[idx - 1];
        const current = self.filteredPositions[idx];

        let timeDiffSeconds = 10;

        if (prev.position_date && current.position_date) {
          try {
            const prevTime = new Date(prev.position_date).getTime() / 1000;
            const currTime = new Date(current.position_date).getTime() / 1000;
            timeDiffSeconds = Math.abs(currTime - prevTime);
          } catch (e) {
            console.warn("Erro ao calcular tempo entre posições:", e);
          }
        }

        if (timeDiffSeconds > GAP_THRESHOLD) {
          if (currentSegment.length > 1) {
            self.routeSegments.push({ path: currentSegment, isGap: false });
          }

          self.createDirectionsSegment(prev, current);

          currentSegment = [current];
        } else {
          currentSegment.push(current);
        }
      }

      if (currentSegment.length > 1) {
        self.routeSegments.push({ path: currentSegment, isGap: false });
      }
    },

    createDirectionsSegment(origin, destination) {
      const self = this;

      const cachedRoute = self.cachedEstimatedRoutes.find((route) => {
        return (
          Math.abs(route.origin_lat - origin.lat) < 0.00001 &&
          Math.abs(route.origin_lng - origin.lng) < 0.00001 &&
          Math.abs(route.destination_lat - destination.lat) < 0.00001 &&
          Math.abs(route.destination_lng - destination.lng) < 0.00001
        );
      });

      if (cachedRoute) {
        // self.renderCachedRoute(cachedRoute);
        return;
      }

      if (!window.google || !window.google.maps) {
        console.warn("Google Maps API não carregada");
        self.routeSegments.push({
          path: [origin, destination],
          isGap: true,
        });
        return;
      }

      const directionsService = new google.maps.DirectionsService();
      // const directionsRenderer = new google.maps.DirectionsRenderer({
      //   suppressMarkers: true,
      //   polylineOptions: {
      //     strokeColor: "#FF6B35",
      //     strokeOpacity: 0.7,
      //     strokeWeight: 3,
      //   },
      // });

      const request = {
        origin: new google.maps.LatLng(origin.lat, origin.lng),
        destination: new google.maps.LatLng(destination.lat, destination.lng),
        travelMode: "DRIVING",
      };

      directionsService.route(request, (result, status) => {
        if (status === "OK") {
          directionsRenderer.setDirections(result);
          directionsRenderer.setMap(self.$refs.mapRef.$mapObject);
          self.directionsRenderers.push(directionsRenderer);

          //self.saveEstimatedRoute(origin, destination, result);
        } else {
          console.warn("Directions request falhou:", status);
          self.routeSegments.push({
            path: [origin, destination],
            isGap: true,
          });
        }
      });
    },

    renderCachedRoute(cachedRoute) {
      const self = this;

      if (!window.google || !window.google.maps) {
        console.warn("Google Maps API não carregada");
        return;
      }

      const directionsRenderer = new google.maps.DirectionsRenderer({
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: "#FF6B35",
          strokeOpacity: 0.7,
          strokeWeight: 3,
        },
      });

      if (cachedRoute.route_data && cachedRoute.route_data.routes) {
        directionsRenderer.setDirections(cachedRoute.route_data);
        directionsRenderer.setMap(self.$refs.mapRef.$mapObject);
        self.directionsRenderers.push(directionsRenderer);
      }
    },

    saveEstimatedRoute(origin, destination, directionsResult) {
      const self = this;
      let api = self.$store.state.api + "save-estimated-route";

      const routeData = {
        removal_id: self.currentRemovalId,
        origin_lat: origin.lat,
        origin_lng: origin.lng,
        destination_lat: destination.lat,
        destination_lng: destination.lng,
        route_data: directionsResult,
        distance_meters:
          directionsResult.routes[0]?.legs[0]?.distance?.value || null,
        duration_seconds:
          directionsResult.routes[0]?.legs[0]?.duration?.value || null,
      };

      axios
        .post(api, routeData)
        .then(() => {
          console.log("Rota estimada salva com sucesso.");
        })
        .catch((error) => {
          console.error("Erro ao salvar rota:", error);
        });
    },

    debounceCard: debounce(function () {
      this.getEntity();
    }, 500),

    getCurrentLocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.currentLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
          },
          (error) => {
            console.error("Erro ao obter localização:", error);
            this.error = "Não foi possível acessar a localização.";
          },
        );
      } else {
        this.error = "Geolocalização não suportada pelo navegador.";
      }
    },

    clearFilters() {
      this.filters = {
        destination_hospital: null,
        start_date: "",
        end_date: "",
        card_number: "",
        status: "",
      };
      this.getEntity();
    },

    getPositions(obj) {
      const self = this;
      let api = self.$store.state.api + "get-remotion/positions";
      self.$loading(true);

      self.selectedRemoval = obj;
      self.currentRemovalId = obj.id;

      axios
        .post(api, { obj: obj })
        .then((response) => {
          const responseData = response.data.positions
            ? response.data
            : {
                positions: response.data,
                estimated_routes: [],
              };

          self.positions = responseData.positions.map((element) => ({
            id: element.id,
            lat: Number(element.lat),
            lng: Number(element.long),
            position_date: element.position_date,
            created_at_f: element.created_at_f || null,
          }));

          self.cachedEstimatedRoutes = responseData.estimated_routes || [];

          if (self.positions.length > 0) {
            self.currentLocation = self.positions[0];
          }

          self.$nextTick(() => {
            self.processRouteSegments();
          });

          setTimeout(() => {
            $("#modalMap").modal("show");
          }, 600);
          self.$loading(false);
        })
        .catch((error) => {
          self.$error(error);
          self.$loading(false);
        });
    },

    exportPDF() {
      if (!this.selectedRemoval) {
        console.error("Nenhuma remoção selecionada!");
        return;
      }

      const self = this;
      self.isLoading = true;

      // Scroll para o mapa ficar visível
      setTimeout(() => {
        const mapElement = self.$refs.mapContainer;
        if (mapElement) {
          mapElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);

      // Aguarda o mapa renderizar completamente
      setTimeout(() => {
        const mapElement = self.$refs.mapContainer;
        const mapRef = self.$refs.mapRef;

        if (!mapElement || !mapRef) {
          console.error("Mapa não encontrado!");
          self.isLoading = false;
          self.$loading(false);
          return;
        }

        const originalZoom = mapRef.$mapObject.getZoom();
        const originalCenter = mapRef.$mapObject.getCenter();

        // Força o Google Maps a recalcular o tamanho do container
        google.maps.event.trigger(mapRef.$mapObject, "resize");

        // Aguarda o resize completar
        setTimeout(() => {
          // Calcula o zoom necessário para caber toda a rota
          const bounds = new google.maps.LatLngBounds();
          self.filteredPositions.forEach((pos) => {
            bounds.extend(new google.maps.LatLng(pos.lat, pos.lng));
          });

          mapRef.$mapObject.fitBounds(bounds);

          // Flag para prevenir execução duplicada
          let captured = false;

          // Aguarda o mapa ficar totalmente idle (tiles carregados)
          const idleListener = google.maps.event.addListenerOnce(
            mapRef.$mapObject,
            "idle",
            () => {
              if (captured) return;
              captured = true;

              setTimeout(() => {
                const calculatedZoom = mapRef.$mapObject.getZoom();

                // Se o zoom for muito baixo (< 10), captura em 3 partes: início, meio e fim
                if (calculatedZoom < 10 && self.filteredPositions.length > 2) {
                  self.captureMultipleMapSegments(
                    mapRef,
                    mapElement,
                    originalZoom,
                    originalCenter,
                  );
                } else {
                  // Captura normal para rastros curtos/médios
                  self.captureSingleMap(
                    mapRef,
                    mapElement,
                    originalZoom,
                    originalCenter,
                    calculatedZoom,
                  );
                }
              }, 500);
            },
          );

          // Fallback caso o evento idle não dispare
          const waitTime = window.innerWidth < 1366 ? 3000 : 2500;
          setTimeout(() => {
            if (captured) return;
            captured = true;

            google.maps.event.removeListener(idleListener);
            const calculatedZoom = mapRef.$mapObject.getZoom();

            if (calculatedZoom < 10 && self.filteredPositions.length > 2) {
              self.captureMultipleMapSegments(
                mapRef,
                mapElement,
                originalZoom,
                originalCenter,
              );
            } else {
              self.captureSingleMap(
                mapRef,
                mapElement,
                originalZoom,
                originalCenter,
                calculatedZoom,
              );
            }
          }, waitTime);
        }, 500);
      }, 700);
    },

    async captureMultipleMapSegments(
      mapRef,
      mapElement,
      originalZoom,
      originalCenter,
    ) {
      const self = this;
      const mapImages = [];
      const zoomLevel = 14; // Zoom bom para detalhes

      // Divide em 3 segmentos: início (30%), meio (40%), fim (30%)
      const totalPoints = self.filteredPositions.length;
      const segments = [
        {
          name: "Início",
          positions: self.filteredPositions.slice(
            0,
            Math.floor(totalPoints * 0.3),
          ),
        },
        {
          name: "Percurso",
          positions: self.filteredPositions.slice(
            Math.floor(totalPoints * 0.3),
            Math.floor(totalPoints * 0.7),
          ),
        },
        {
          name: "Fim",
          positions: self.filteredPositions.slice(
            Math.floor(totalPoints * 0.7),
          ),
        },
      ];

      try {
        for (let i = 0; i < segments.length; i++) {
          const segment = segments[i];

          if (segment.positions.length === 0) continue;

          // Calcula o centro do segmento
          const segmentBounds = new google.maps.LatLngBounds();
          segment.positions.forEach((pos) => {
            segmentBounds.extend(new google.maps.LatLng(pos.lat, pos.lng));
          });

          const center = segmentBounds.getCenter();
          mapRef.$mapObject.setCenter(center);
          mapRef.$mapObject.setZoom(zoomLevel);

          // Trigger resize para garantir renderização correta
          google.maps.event.trigger(mapRef.$mapObject, "resize");

          // Aguarda o mapa ficar idle
          await new Promise((resolve) => {
            google.maps.event.addListenerOnce(mapRef.$mapObject, "idle", () => {
              // Aumentado tempo de espera após idle para garantir tiles carregados
              const extraWaitTime = window.innerWidth < 1366 ? 2500 : 2000;
              setTimeout(resolve, extraWaitTime);
            });

            // Fallback caso idle não dispare
            const waitTime = window.innerWidth < 1366 ? 4000 : 3500;
            setTimeout(resolve, waitTime);
          });

          // Captura
          const canvas = await html2canvas(mapElement, {
            useCORS: true,
            scale: 2.5,
            logging: false,
            allowTaint: true,
            backgroundColor: "#ffffff",
            removeContainer: true,
            imageTimeout: 15000,
            scrollY: -window.scrollY,
            scrollX: -window.scrollX,
            windowHeight: mapElement.scrollHeight,
            windowWidth: mapElement.scrollWidth,
          });

          const imgData = canvas.toDataURL("image/jpeg", 0.85);
          mapImages.push({ name: segment.name, data: imgData });
        }

        // Restaura mapa
        mapRef.$mapObject.setCenter(originalCenter);
        mapRef.$mapObject.setZoom(originalZoom);

        // Envia todas as imagens para o backend
        let formData = new FormData();
        mapImages.forEach((img, index) => {
          formData.append(`mapImage${index}`, img.data);
          formData.append(`mapImageName${index}`, img.name);
        });
        formData.append("mapImagesCount", mapImages.length);
        formData.append("removal", JSON.stringify(self.selectedRemoval));
        formData.append(
          "removal_start",
          self.selectedRemoval.start_date_f ||
            self.selectedRemoval.start_date ||
            "",
        );
        formData.append(
          "removal_end",
          self.selectedRemoval.end_date_f ||
            self.selectedRemoval.end_date ||
            "",
        );

        axios
          .post(self.$store.state.api + "export-remotions-pdf", formData, {
            responseType: "blob",
            timeout: 300000,
          })
          .then((response) => {
            let blob = new Blob([response.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();
          })
          .catch((error) => {
            self.$error(error);
          })
          .finally(() => {
            self.isLoading = false;
            self.$loading(false);
          });
      } catch (err) {
        console.error("Erro ao capturar segmentos:", err);
        mapRef.$mapObject.setCenter(originalCenter);
        mapRef.$mapObject.setZoom(originalZoom);
        self.isLoading = false;
        self.$loading(false);
      }
    },

    captureSingleMap(
      mapRef,
      mapElement,
      originalZoom,
      originalCenter,
      calculatedZoom,
    ) {
      const self = this;

      console.log("[PDF Export] Captura single - Zoom:", calculatedZoom);

      // Usa o zoom calculado pelo fitBounds, garantindo que toda a rota apareça
      // Não adiciona zoom extra para evitar cortar a rota
      mapRef.$mapObject.setZoom(calculatedZoom);

      // Força resize do mapa
      google.maps.event.trigger(mapRef.$mapObject, "resize");

      // Aguarda o mapa ficar idle (tiles totalmente carregados)
      google.maps.event.addListenerOnce(mapRef.$mapObject, "idle", () => {
        // Aguarda tempo extra após o idle para garantir que os tiles estejam todos carregados
        const extraWaitTime = window.innerWidth < 1366 ? 2500 : 2000;

        setTimeout(async () => {
          html2canvas(mapElement, {
            useCORS: true,
            scale: 2.5,
            logging: false,
            allowTaint: true,
            backgroundColor: "#ffffff",
            removeContainer: true,
            imageTimeout: 15000,
            scrollY: -window.scrollY,
            scrollX: -window.scrollX,
            windowHeight: mapElement.scrollHeight,
            windowWidth: mapElement.scrollWidth,
          })
            .then(async (canvas) => {
              mapRef.$mapObject.setCenter(originalCenter);
              mapRef.$mapObject.setZoom(originalZoom);

              const imgData = canvas.toDataURL("image/jpeg", 0.85);

              if (!imgData || imgData === "data:,") {
                console.error("Erro ao capturar o mapa.");
                self.isLoading = false;
                self.$loading(false);
                return;
              }

              let formData = new FormData();
              formData.append("mapImage", imgData);
              formData.append("removal", JSON.stringify(self.selectedRemoval));
              formData.append(
                "removal_start",
                self.selectedRemoval.start_date_f ||
                  self.selectedRemoval.start_date ||
                  "",
              );
              formData.append(
                "removal_end",
                self.selectedRemoval.end_date_f ||
                  self.selectedRemoval.end_date ||
                  "",
              );

              axios
                .post(
                  self.$store.state.api + "export-remotions-pdf",
                  formData,
                  {
                    responseType: "blob",
                    timeout: 300000,
                  },
                )
                .then((response) => {
                  let blob = new Blob([response.data], {
                    type: "application/pdf",
                  });
                  let link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.target = "_blank";
                  link.click();
                })
                .catch((error) => {
                  self.$error(error);
                })
                .finally(() => {
                  self.isLoading = false;
                  self.$loading(false);
                });
            })
            .catch((err) => {
              console.error("Erro ao capturar imagem do mapa:", err);
              mapRef.$mapObject.setCenter(originalCenter);
              mapRef.$mapObject.setZoom(originalZoom);
              self.$loading(false);
              self.isLoading = false;
            });
        }, extraWaitTime);
      });
    },

    generateGoogleMapsUrl() {
      // Gera URL do Google Maps com o trajeto completo
      if (!this.filteredPositions || this.filteredPositions.length === 0) {
        return "";
      }

      const origin = `${this.filteredPositions[0].lat},${this.filteredPositions[0].lng}`;
      const destination = `${
        this.filteredPositions[this.filteredPositions.length - 1].lat
      },${this.filteredPositions[this.filteredPositions.length - 1].lng}`;

      // Adiciona waypoints intermediários (limite de 9 para evitar URL muito longa)
      const waypoints = [];
      if (this.filteredPositions.length > 2) {
        // Reduzido de 20 para 9 waypoints para evitar URL muito longa
        const maxWaypoints = Math.min(9, this.filteredPositions.length - 2);
        const step = Math.ceil(
          (this.filteredPositions.length - 2) / maxWaypoints,
        );

        for (let i = 1; i < this.filteredPositions.length - 1; i += step) {
          if (waypoints.length >= maxWaypoints) break;
          waypoints.push(
            `${this.filteredPositions[i].lat},${this.filteredPositions[i].lng}`,
          );
        }
      }

      let url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
        origin,
      )}&destination=${encodeURIComponent(destination)}&travelmode=driving`;

      if (waypoints.length > 0) {
        url += `&waypoints=${encodeURIComponent(waypoints.join("|"))}`;
      }

      return url;
    },

    getEntity(page = 1) {
      const api = this.$store.state.api + "get-remotions";
      const statusParam =
        this.filters.status === "" ||
        this.filters.status === null ||
        typeof this.filters.status === "undefined"
          ? ""
          : Number(this.filters.status);
      const params = {
        page,
        destination_hospital: this.filters.destination_hospital,
        card_number: this.filters.card_number,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        status: statusParam,
      };
      this.loadingRemotions = true;
      axios
        .post(api, params)
        .then((response) => {
          this.removals = response.data.data || [];
          this.pagination = {
            current_page: response.data.current_page || 1,
            last_page: response.data.last_page || 1,
            per_page: response.data.per_page || 15,
            total: response.data.total || 0,
            from: response.data.from || 0,
            to: response.data.to || 0,
          };
        })
        .catch((error) => {
          this.$error(error);
        })
        .finally(() => {
          this.loadingRemotions = false;
        });
    },

    goToPage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.getEntity(page);
      }
    },

    getDestination() {
      const api = this.$store.state.api + "hospitals/actives";
      this.$loading(true);
      axios
        .get(api)
        .then((response) => {
          this.destinos = response.data || [];
        })
        .catch((error) => {
          this.$error(error);
        })
        .finally(() => this.$loading(false));
    },
    exportExcel() {
      const api = this.$store.state.api + "export-removals";
      const statusParam =
        this.filters.status === "" ||
        this.filters.status === null ||
        typeof this.filters.status === "undefined"
          ? ""
          : Number(this.filters.status);
      const params = {
        destination_hospital: this.filters.destination_hospital,
        card_number: this.filters.card_number,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        status: statusParam,
      };

      this.isLoading = true;
      this.$loading(true);

      axios
        .post(api, params, { responseType: "blob", timeout: 300000 })
        .then((response) => {
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: contentType });

          // tenta obter filename do header Content-Disposition
          let filename = "removals.xlsx";
          const cd = response.headers["content-disposition"];
          if (cd) {
            const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/);
            if (match && match[1]) {
              try {
                filename = decodeURIComponent(match[1]);
              } catch (e) {
                filename = match[1];
              }
            }
          }

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          this.$error(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.$loading(false);
        });
    },

    // Método para determinar o ícone do marcador com base na posição (início, meio, fim)
    markerIcon(index, total) {
      if (total === 1) {
        // Apenas um ponto, ícone neutro
        return require("@/assets/images/logo/icons8-bola-24.svg");
      } else if (index === 0) {
        // Primeiro ponto
        return require("@/assets/images/logo/icons8-mapa-start-24.svg");
      } else if (index === total - 1) {
        // Último ponto
        return require("@/assets/images/logo/icons8-mapa-end-24.svg");
      } else {
        // Pontos intermediários
        return require("@/assets/images/logo/icons8-bola-24.svg");
      }
    },

    // Método chamado ao clicar em um marcador de posição
    openPositionInfo(position, index) {
      this.infoWindowPosition = position;
      this.infoWindowOpened = true;

      // Atualiza o conteúdo da InfoWindow
      this.infoWindowContent = {
        indexLabel: `Ponto ${index + 1}`,
        lat: position.lat,
        lng: position.lng,
        time: position.created_at_f,
      };
    },

    // Método chamado ao fechar a InfoWindow
    closePositionInfo() {
      this.infoWindowOpened = false;
    },
  },
  mounted() {
    // Aplica zoom de 80% PERMANENTE em notebooks
    if (window.innerWidth <= 1366) {
      document.body.style.zoom = "80%";
    }

    this.getDestination();
    this.getCurrentLocation();
    setTimeout(() => {
      this.getEntity();
    }, 500);
  },
  beforeDestroy() {
    // Restaura zoom ao sair da página
    document.body.style.zoom = "";
  },
};
</script>
